// System
import React, { useMemo } from 'react';
// Components
import { TableBodyEx, TableContainerEx, TableEx } from '@Components/shared/tables/components';
import {
  ColumnVisibilityPresenter,
  TableHeadColumnsPresenter,
  TableHeadPresenter,
  TableRowPresenter,
} from '@Components/shared/tables/presenters';
import { LoadingScreen } from '@Components/shared/loaders/LoadingScreen';
// Utils
import { applyColumnVisibility } from '@utils/data/applyColumnVisibility';
// Table
import { useScheduledSendCreditTasksTableColumns } from './useScheduledSendCreditTasksTableColumns';
// Types
import { ScheduledSendCreditTaskItemDto } from '@contracts/api/dto/scheduledSendCreditTask/ScheduledSendCreditTask';
// Redux
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
import { useScheduledSendCreditTasksTable } from '@Modal/hooks/scheduledSendCreditTasks/useScheduledSendCreditTasksTable';
import { useScheduledSendCreditTasksQuery } from '@Src/generated.graphql';

export const ScheduledSendCreditTasksTable: React.FC = () => {
  const { columnVisibility, visiblityCustomizable, scheduledSendCreditTasksListFilters } =
    useScheduledSendCreditTasksTable();
  const { userPermissions, currentUser } = useAuthorization();
  const columns = useScheduledSendCreditTasksTableColumns();

  const permissionToViewFailedSendCreditTasks =
    userPermissions?.includes('CAN_VIEW_SCHEDULED_SEND_CREDIT_TASKS') || currentUser.isSuper;

  const { data, loading } = useScheduledSendCreditTasksQuery({
    skip: !permissionToViewFailedSendCreditTasks,
  });
  const visibleColumns = useMemo(
    () => applyColumnVisibility(columns, scheduledSendCreditTasksListFilters),
    [columns, columnVisibility]
  );

  const header = useMemo(
    () => (
      <TableHeadPresenter>
        <TableHeadColumnsPresenter columns={visibleColumns} />
        {/* @ts-ignore */}
        <ColumnVisibilityPresenter columns={columns} content={visiblityCustomizable} />
      </TableHeadPresenter>
    ),
    [columns]
  );

  if (!permissionToViewFailedSendCreditTasks) return <h1>No Permission</h1>;
  if (loading) return <LoadingScreen />;

  return (
    <>
      <TableContainerEx sx={{ height: '70vh' }}>
        <TableEx name="aviatorFailedSendCreditTasks">
          {header}
          <TableBodyEx>
            {/* @ts-ignore */}
            {data?.aviatorScheduledSendCreditTasks?.map(
              // @ts-ignore
              (row: ScheduledSendCreditTaskItemDto) => (
                <TableRowPresenter
                  id={row.id}
                  key={row.id}
                  columns={visibleColumns}
                  row={row}
                  onClick={() => {}}
                />
              )
            )}
          </TableBodyEx>
        </TableEx>
      </TableContainerEx>
    </>
  );
};
